import React from "react";

const solid = (colour) =>
  colour.replace(/rgba\((\d+), (\d+), (\d+), [\d.]+\)/, "rgba($1, $2, $3, 1)");

const ColorPicker = ({
  colours,
  pattern,
  thumbnailColourOverride = null,
  setColourPreference,
  isSelected = false,
  label,
}) => (
  <button
    type="button"
    className="color-picker"
    aria-pressed={isSelected}
    aria-label={label}
    title={label}
    style={{
      background: solid(thumbnailColourOverride || colours[0]),
      backgroundImage: pattern,
    }}
    onClick={() => setColourPreference(colours, pattern)}
  />
);

export default ColorPicker;
